<template>
  <el-carousel height="10vw" direction="vertical" :autoplay="true" indicator-position="none">
    <el-carousel-item v-for="(url, index) in ads" :key="index">
      <!-- 测试 -->
      <!-- <img src="https://s21.ax1x.com/2025/06/17/pVEGpvt.png" :alt="url"/> -->
      <!-- 正式 -->
     <img :src="imgUrl?.url.replace(/\/$/, '')+url" :alt="url"/>
     <!-- <img :src="'http://127.0.0.1'+url" :alt="url"/> -->
    </el-carousel-item>
  </el-carousel>
</template>


<script>
  export default {
    name: "AdSlogen",
    props: {
      imgUrl: {
        type: Object,
        default: {}, // 默认空数组
      },
      ads: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        // ads: [{
        //     url: "https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg"
        //   },
        //   {
        //     url: "https://s21.ax1x.com/2024/05/15/pknZ2N9.jpg"
        //   },
        //   {
        //     url: "https://s21.ax1x.com/2024/05/09/pkVRRSA.jpg"
        //   },
        //   {
        //     url: "https://s21.ax1x.com/2024/05/09/pkVRsoD.jpg"
        //   },
        //   {
        //     url: "https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg"
        //   },
        // ],
      };
    },
  };
</script>

<style>
  /* .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  } */
  .el-carousel__item img{
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>
